<template>
  <div class="time-card">
    <img class="time-card__image" alt="time_card_image" :src="imageUrl" />
    <div class="time-card__meta">
      <div class="time-card__title d-flex">
        <img :src="iconUrl" alt="icon" />
        {{ title }}
      </div>
      <div class="time-card__impact">
        {{ translationKey }}
      </div>
    </div>
  </div>
</template>

<script>
import constants from '@/components/Rev/Review/TimeImpact/constants.js'

export default {
  name: 'TimeImpactCard',

  props: {
    title: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    iconUrl: {
      type: String,
      required: true,
    },
    timeImpact: {
      type: Number,
      required: true,
    },
    timeUnit: {
      type: String,
      required: false,
    },
  },

  data() {
    return { constants }
  },

  computed: {
    translationKey() {
      switch (this.timeUnit) {
        case this.constants.timeUnits.hour:
          return this.$t('common.time.hourWithCount', {
            count: this.timeImpact,
          })
        case this.constants.timeUnits.week:
          return this.$t('common.time.weekWithCount', {
            count: this.timeImpact,
          })
        case this.constants.timeUnits.day:
          return this.$t('common.time.dayWithCount', {
            count: this.timeImpact,
          })
        case this.constants.timeUnits.minute:
          return this.$t('common.time.minuteWithCount', {
            count: this.timeImpact,
          })
        default:
          return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.time-card {
  box-shadow: 0px 1px 2px rgba(120, 135, 155, 0.3);
  border-radius: 4px;
  background: $color-white;
  display: flex;

  &__image {
    margin: 8px 8px 16px 16px;
  }

  &__meta {
    margin-top: 28px;
    margin-right: 24px;
  }

  &__title {
    color: $color-blue-grey-darken1;
    font-size: 12px;
    margin-bottom: 8px;

    img {
      margin-right: 8px;
    }
  }

  &__impact {
    color: $color-blue-grey-darken3;
    font-size: 20px;
    font-weight: 600;
  }
}
</style>
